// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Mmdvh","title":"Images45_title__14f84","images":"Images45_images__2VUWo"};